import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import { NumericFormat } from "react-number-format";
import * as S from './styled';
/**
 * Components
*/
import { useEffect } from 'react';
import LayoutModal from '../../../LayoutModal';
import Loading from "../../../Loading";
/**
 * hooks 
*/
import { apiUpdate } from '../../../../hooks/apiUpdate';
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from "../../../../hooks/useLoading";
/**
 * Interface 
*/
import { Inputs } from 'Interfaces/IService';

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
  updateList: () => void;
}

export default function Update({ isOpenModal, setModalClose, updateList, selectedUrlId }: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const response = await axiosInstance.get(`service/${selectedUrlId}`);
        const addressData = response.data;
        for (const key in addressData) {
          setValue(key as keyof Inputs, addressData[key]);
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);


  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(`service/${selectedUrlId}`, 'PATCH', data);
      if (response.status === 200) {
        alert("Serviço atualizado com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.error || error.message || "Ocorreu um erro ao atualizar.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Serviço"
        subTitle="Atualize informações do serviço em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Serviço'}
      >
        {
          isLoading ? (
            <Loading />
          ) :
            <S.Container>
              <S.SeparateDiv>
                <S.FormInput>
                  <S.Label>
                    Nome do Serviço
                    <span>*</span>
                  </S.Label>
                  <S.Input
                    placeholder="Informe o serviço"
                    type="text"
                    {...register("name", { required: true })}
                  />
                  {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>

                <S.FormInput>
                  <S.Label>
                    Valor da Venda R$
                    <span>*</span>
                  </S.Label>
                  <Controller
                    name="price"
                    control={control}
                    rules={{ required: "Este campo é obrigatório" }}
                    render={({ field: { onChange, value, ref } }) => (
                      <NumericFormat
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={true}
                        placeholder="R$ 0,00"
                        prefix="R$ "
                        value={value}
                        onValueChange={(values) => {
                          const purchaseValue = values.floatValue ?? 0;
                          onChange(purchaseValue);
                        }}
                        getInputRef={ref}
                      />
                    )}
                  />
                  {errors.price && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>
              </S.SeparateDiv>

              <S.FormInput>
                <S.Label>Descrição</S.Label>
                <S.TextArea
                  placeholder="Campo Opcional"
                  rows={2}
                  {...register("description")}
                />
              </S.FormInput>
            </S.Container>
        }

      </LayoutModal>
    );
  }
  return null;
}